import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'

import {viewEmployers} from '../employers-list/core/_requests'
import {EditEmployers} from '../employers-form/EditEmployers'

export const EditEmployersWrapper = () => {
  const {id} = useParams()
  const [data, setData] = useState<any>(null)
  useEffect(() => {
    viewEmployers(id).then((res) => {
      setData(res.Data)
    })
  }, [])
  if (data) {
    return <EditEmployers initialValues={data} />
  }
  return null
}
